import { Link } from "react-router-dom";

export type MapBadgeProps = {
  link?: string;
  number?: number;
}
const MapBadge = ({link, number}: MapBadgeProps) => {
  return (
    <div className="flex gap-1">
      <Link to={link ?? "#"}>
        <button className="border flex items-center py-0.5 px-2 rounded-full border-black gap-1 relative">
          <svg
            className="w-4 h-4 text-gray-800"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z"
            />
          </svg>
          <span className="text-xs">지도링크{number && number}번</span>
        </button>
      </Link>
    </div>
  );
};

export default MapBadge;